import { withTryToInvokeTrackingEvent } from '@utils/exponea-logging';

export const trackExponeaWishlistUpdate = withTryToInvokeTrackingEvent(
  'WishlistUpdate',
  (payload: Parameters<typeof window.trackingEvents.WishlistUpdate>[0]) => {
    void window.trackingEvents.WishlistUpdate(payload);
  }
);
